import React from 'react';
import type { ClearIndicatorProps, GroupBase } from 'react-select';

const ClearIndicator = <Option, IsMulti extends boolean = false, Group extends GroupBase<Option> = GroupBase<Option>>({
    className,
    cx,
    innerProps,
}: ClearIndicatorProps<Option, IsMulti, Group>) => (
    <div {...innerProps} className={cx({ indicator: true, 'clear-indicator': true }, className)}>
        <svg width="23" height="23" viewBox="0 0 20 20">
            <path d="m15.2954 14.1358-1.1707 1.1707-4.13028-4.1304-4.11927 4.1193-1.17062-1.1706 4.11927-4.1193-4.11927-4.13029 1.17062-1.17062 4.11927 4.11927 4.13028-4.13032 1.1817 1.18167-4.1303 4.13029 4.1193 4.1303Z" />
        </svg>
    </div>
);

export default ClearIndicator;
